import axios from "axios";

// The flow of a sub project as the runtime receives it (the Firebase functions' mapProject), for comparing versions.
// Both sides go through the same mapping: the raw Firestore documents differ in shape from the mapped flow, so
// comparing a raw version with the mapped latest flow would show every field as changed.
export const LATEST = "__latest__";

const FUNCTIONS_URL = process.env.REACT_APP_FIREBASE_FUNCTIONS_URL;

// Fields the functions add per request, not part of the flow
const withoutRequestFields = ({version_id, debug_id, ...flow}) => flow;

// versionUid: a ProjectVersionDTO.versionUid, or LATEST for the flow as it is now in the designer
export const loadFlowSnapshot = async (flowUid, versionUid, signal) => {
  if (versionUid === LATEST) {
    const response = await axios.get(`${FUNCTIONS_URL}/api/apiCurrentProject/${flowUid}`, {signal});
    return withoutRequestFields(response.data || {});
  }
  const response = await axios.get(`${FUNCTIONS_URL}/api/apiProject/${flowUid}`, {params: {versionId: versionUid}, signal});
  // apiProject falls back to the newest version when it does not find this one
  if (response.data?.version_id !== versionUid) {
    throw new Error("The snapshot of this version was not found");
  }
  return withoutRequestFields(response.data);
};

// Replaces the sub project's flow (what the designer edits) with a saved version. The version is kept, and the
// fields the Project API owns (name, members, settings ...) keep their current values; the deployed stage /
// production versions do not change until a new version is saved.
export const revertFlowToVersion = (flowUid, versionUid) =>
  axios.post(`${FUNCTIONS_URL}/api/apiProject/${flowUid}/revert/${encodeURIComponent(versionUid)}`);
